import { render, staticRenderFns } from "./Datos.vue?vue&type=template&id=0d353018&scoped=true&"
import script from "./Datos.vue?vue&type=script&lang=js&"
export * from "./Datos.vue?vue&type=script&lang=js&"
import style0 from "./Datos.vue?vue&type=style&index=0&id=0d353018&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d353018",
  null
  
)

export default component.exports